class UploadService {

    async getAuthorizationUploadReferencesFile (fileName, token, userID) {
        const response = await fetch(`${process.env.REACT_APP_API}/ta/candidates/upload-references?fileName=${fileName}&id=${userID}`, {
            method: 'GET',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Basic ' + token,
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
        });

        return response.json();
    }

    async getAuthorizationUploadImageFile (fileName, token, userID) {
        const response = await fetch(`${process.env.REACT_APP_API}/ta/candidates/upload-profile-image?fileName=${fileName}&id=${userID}`, {
            method: 'GET',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Basic ' + token,
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
        });

        return response.json();
    }

    async getAuthorizationUploadPresentationFile (fileName, token, userID) {
        const response = await fetch(`${process.env.REACT_APP_API}/ta/candidates/upload-presentation?fileName=${fileName}&id=${userID}`, {
            method: 'GET',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Basic ' + token,
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
        });

        return response.json();
    }

    async UploadFile (url, file, type) {
        fetch( url, {
            method: 'PUT',
            mode: 'cors',
            headers: {
                'Content-type': type==='image' ? 'image': type==='pdf' ? 'application/pdf' : 'application/json',
            },
            body: file,
        });
    }
}
export default new UploadService();
